import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "image-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_TransitionGroup, {
      name: "fade",
      class: "album-container"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums, (album) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "grid-item",
            key: album.id
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_router_link, {
                to: {name: 'DisplayPhoto', params:
                {albumName: album.name, id: album.id}},
                id: album.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.cover(album.photos[0])
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["to", "id"])
            ]),
            _createElementVNode("p", _hoisted_3, _toDisplayString(album.name), 1)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}